import React from "react";

/**
 * Small centered loading spinner. Used as a visual replacement
 * for inline "Loading…" text across the app.
 */
export default function CenteredSpinner({ size = 24, className = "" }) {
  const border = Math.max(2, Math.round(size / 8));
  return (
    <div
      className={`w-full flex items-center justify-center py-4 ${className}`}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <span
        style={{
          width: size,
          height: size,
          border: `${border}px solid var(--surface-3)`,
          borderTopColor: "var(--accent-700)",
          borderRadius: "50%",
          display: "inline-block",
          animation: "sp-spin 0.9s linear infinite",
        }}
      />
      <style>{`@keyframes sp-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
